import { IDashboardContext } from "../../contexts/dashboard-context";

export function isTemplatesPanelSupported(
	page: eXpress.core.IZone | null | undefined,
	dashboard: IDashboardContext,
) {
	// TODO: return false if there are no templates for the current page?
	return dashboard.canAddTemplateToPage(page);
}
